import React, { useState } from 'react';
import '../../assets/styles/CategorySection.css';
import PropTypes from 'prop-types';

const iconsMap = {
    document: "📄",
    structure: "📑",
    history: "🏛️",
    people: "👥",
    linguistics: "📝",
    geography: "🌍",
    culture: "🎭",
    analysis: "🔍",
    research: "📚",
};

const CategorySection = ({ data, onQuestionClick, isRTL }) => {

    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="category-section">
            <button
                className="category-trigger"
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="category-info">
                    <span className="category-icon">{iconsMap[data.icon] || "❓"}</span>
                    <span className="category-title">{data.title}</span>
                </div>
                <svg
                    className={`chevron ${isOpen ? 'chevron-up' : 'chevron-down'}`}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                >
                    <polyline points="6,9 12,15 18,9"></polyline>
                </svg>
            </button>

            <div className={`category-content ${isOpen ? 'content-open' : 'content-closed'}`}>
                <div className="questions-list">
                    {data.questions.map((question, index) => (
                        <button
                            key={index}
                            className="question-button"
                            onClick={() => onQuestionClick(question)}
                            style={{
                                textAlign: isRTL ? 'right' : 'left',
                                direction: isRTL ? 'rtl' : 'ltr'
                            }}
                        >
                            {question}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

CategorySection.propTypes = {
    data: PropTypes.shape({
        icon: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        questions: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
    onQuestionClick: PropTypes.func.isRequired,
    isRTL: PropTypes.bool.isRequired,
};

export default CategorySection;